import React, { useEffect, useMemo, useRef, useState } from "react"
import { GoogleMap, MarkerF, Autocomplete, useLoadScript } from "@react-google-maps/api"

const libraries = ["places"]
const containerStyle = { width: "100%", height: 320 }

export default function MapPicker({
  apiKey,
  value, // { lat: number|null, lng: number|null }
  onChange, // ({ lat, lng }) => void
  defaultCenter = { lat: -6.2, lng: 106.816666 }, // Jakarta
  disabled = false,
}) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries,
  })

  const [center, setCenter] = useState(defaultCenter)
  const autocompleteRef = useRef(null)

  const position = useMemo(() => {
    if (typeof value?.lat === "number" && typeof value?.lng === "number") {
      return { lat: value.lat, lng: value.lng }
    }
    return null
  }, [value])

  useEffect(() => {
    if (position) setCenter(position)
  }, [position])

  const setLatLng = (lat, lng) => {
    onChange?.({ lat, lng })
    setCenter({ lat, lng })
  }

  const onMapClick = (e) => {
    if (disabled) return
    const lat = e.latLng.lat()
    const lng = e.latLng.lng()
    setLatLng(lat, lng)
  }

  const onMarkerDragEnd = (e) => {
    const lat = e.latLng.lat()
    const lng = e.latLng.lng()
    setLatLng(lat, lng)
  }

  const onPlaceChanged = () => {
    const ac = autocompleteRef.current
    if (!ac) return
    const place = ac.getPlace()
    const loc = place?.geometry?.location
    if (!loc) return
    setLatLng(loc.lat(), loc.lng())
  }

  if (loadError) return <div className="text-sm text-red-600">Failed to load Google Maps.</div>
  if (!isLoaded) return <div className="text-sm text-neutral-600">Loading map…</div>

  return (
    <div className="space-y-3">

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={position ? 16 : 12}
        onClick={onMapClick}
        options={{
          disableDefaultUI: false,
          clickableIcons: false,
          gestureHandling: disabled ? "none" : "greedy",
        }}
      >
        {position ? (
          <MarkerF position={position} draggable={!disabled} onDragEnd={onMarkerDragEnd} />
        ) : null}
      </GoogleMap>
    </div>
  )
}
